import { getCountry, getLanguage } from './locale-helper';
import { env } from '$env/dynamic/public';
import { DOMAINS } from '$lib/constants/domains';

export const parseContentVariables = (
  pagePath: string | null,
  rawContent?: string,
  inputLocale?: SupportedLocale
): string | null => {
  if (!rawContent) {
    return null;
  }

  let localeCode: SupportedLocale | undefined = inputLocale;
  let path: string | null = pagePath;

  // We ensure env and public environment is available so that we do not accidentally set it to staging in a cases
  // where said variable is missing (which should never happen).
  const rootDomain: string =
    env?.PUBLIC_ENVIRONMENT && env.PUBLIC_ENVIRONMENT !== 'production' ? DOMAINS.STAGING : DOMAINS.PRODUCTION;

  // If using contentful default en locale code, fall back to en-US
  if (!localeCode || localeCode === 'en') {
    localeCode = 'en-US';
  }

  if (!path) {
    path = '';
  }

  const langCode = getLanguage(localeCode);
  const countryCode = getCountry(localeCode);
  const locale = `${countryCode}/${langCode}`;

  return rawContent
    .replaceAll(DOMAINS.PRODUCTION, rootDomain) // This automatically replaces squareup.com links with squareupstaging similar to how XMS works.
    .replaceAll('{locale}', locale)
    .replaceAll('{locale_code}', localeCode)
    .replaceAll('{country_code}', countryCode)
    .replaceAll('{lang_code}', langCode)
    .replaceAll('{page_path}', path)
    .replaceAll('{square_root_domain}', rootDomain);
};
